import { recoilSelector } from 'common/util/recoil-selector';
import { ComponentsTheme, THEMED_COMPONENT } from '../themes';
import { createStylesGetter } from '../utils';

const preparePlotsStyles = (plotsTheme: ComponentsTheme[THEMED_COMPONENT.PLOTS]): string[] => Object.values(plotsTheme);

export const plotsStylesState = recoilSelector({
  key: THEMED_COMPONENT.PLOTS,
  get: createStylesGetter(preparePlotsStyles, THEMED_COMPONENT.PLOTS),
});
